import React from "react";
import cl from './Main.module.css'
import qr from './qr-code__1_-removebg.png'
import profile from './qr_profile.svg'
import { useEffect } from "react";
import { useState } from "react";

const Main = () => {
    const tg = window.Telegram.WebApp;
    const [platform, setPlatform] = useState('');
    const [username, setUsername] = useState('');
    const [chatId, setChatId] = useState('');
    const [feedback, setFeedback] = useState('');
    const [expiryTime, SetExpiryDate] = useState('');

    useEffect(() => {
        if (window.Telegram && window.Telegram.WebApp) {
            const user = window.Telegram.WebApp.initDataUnsafe?.user;
            if (user) {
                setPlatform(window.Telegram.WebApp.platform);
                setUsername(user.username || user.id);
                setChatId(user.id)
            }
        }

        async function FindUser() {
          try {
            const response = await fetch(`https://elr1c.ru/api/inbounds_list?id=${chatId}`);
            
            // Проверяем успешность ответа  
            if (!response.ok) {
              throw new Error(`Error: ${response.statusText}`);
            }
        
            // Преобразуем ответ в JSON
            const data = await response.json();
            const data_form = data['result'][0]['feedback'] ;
            const expiryTimestamp = data['result'][0]?.['clients']?.[0]?.['expiryTime'] ?? 2;
            if (expiryTimestamp === 0) {
              SetExpiryDate("У вас пожизненная подписка"); 
          } else if (!expiryTimestamp || expiryTimestamp < Date.now()) {
              // Если expiryTimestamp отсутствует или меньше текущей даты (подписка истекла)
              SetExpiryDate("Вы не оплатили подписку"); 
          } else {
              const expiryDate = new Date(expiryTimestamp);
              SetExpiryDate(expiryDate.toLocaleString("ru-RU")); // Форматируем дату
          }
          
            // Выводим данные в консоль и устанавливаем их в состояние
            setFeedback(data_form);
            console.log(data_form);  // Логируем данные, чтобы убедиться в их правильности
          } catch (error) {
            console.error('Ошибка при запросе:', error);
          }
        }

        

        FindUser();
    }, [chatId]);

    const handleConnect = async () => {
      try {
          // Данные для тела запроса
          const data = {
              id: 3,  // Пример ID, замените на нужный
              settings: JSON.stringify({
                  clients: [{
                      id: "",
                      flow: "",
                      email: username,
                      limitIp: 0,
                      totalGB: 0,
                      expiryTime: 0,
                      enable: true,
                      tgId: "",
                      subId: "",
                      reset: 0
                  }]
              })
          };
  
          // Отправка запроса с телом
          const response = await fetch(`https://elr1c.ru/api/add_client?id=${chatId}&username=${username || chatId}`, {
              method: 'POST',  // Метод запроса
              headers: {
                  'Content-Type': 'application/json',  // Указываем, что данные в теле запроса в формате JSON
              },
              body: JSON.stringify(data),  // Преобразуем объект в строку JSON
          });
  
          if (response.ok) {
            if (window.Telegram.WebApp.HapticFeedback) {
              window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
          }
              // Запрос успешно завершен, теперь можно перезагрузить Mini App
              window.Telegram.WebApp.showPopup({
                title: 'Успешно!',
                message: 'Для получения ссылки нужно перезайти!',
                buttons: [
                    {
                        id: 'close_app_button',
                        type: 'close', // Закрывает только popup
                        text: 'Закрыть'
                    },
                    
                ]
            });
            window.Telegram.WebApp.onEvent('popupClosed', (event) => {
              if (event.button_id === 'close_app_button') {
                  window.Telegram.WebApp.close(); // Закрытие приложения
              }
          });
          
          } else {
              // Обработка ошибок, если сервер вернул неуспешный ответ
              console.error('Ошибка при подключении:', response.statusText);
          }
      } catch (error) {
          console.error('Ошибка при отправке запроса:', error);
      }
  };
  

    const copyTextToClipboard = async (text) => {
        try {
          if (window.Telegram.WebApp.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
        }
        tg.showAlert('Для подключения ознакомтесь с инструкцией в боте!');
          await navigator.clipboard.writeText(text);
          console.log('Текст успешно скопирован в буфер обмена!');
          
          
            
        } catch (err) {
          console.error('Ошибка:', err);
        }
      };
    
      const copyTextToClipboardMobile = async (text) => {
        try {
          if (window.Telegram.WebApp.HapticFeedback) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
        }
        tg.showAlert('Успешно скопированно!');
          await navigator.clipboard.writeText(text);
          console.log('Текст успешно скопирован в буфер обмена!');
          
          
            
        } catch (err) {
          console.error('Ошибка:', err);
        }
      };

    window.Telegram.WebApp.setBackgroundColor('#FFFFFF');
    window.Telegram.WebApp.setHeaderColor('#B31217');

    return (
        <>
              {platform !== 'tdesktop' && platform !== 'macos' ? (
        <div className={cl.VpnWrap}>
          <div className={cl.Profile}>
            <img src={profile} alt="Profile" />
            <p>{username}</p>
          </div>
          <div className={cl.VpnWrapAction}>
            {/* Условие для "Скопировать ссылку" */}
            {feedback === "Client was found" ? (
              
              <div>
                <input
                  type="button"
                  value="Скопировать ссылку"
                  className={cl.ConnectBtn}
                  onClick={() => copyTextToClipboard(`vless://${chatId}@elr1c.ru:34208?type=tcp&security=none#elr1c_w0rk-${username}`)} // Логика копирования
                />
                
              </div>
            ) : (
              <input
                type="button"
                value="Подписка истекла"
                className={cl.ConnectBtn}
                // onClick={handleConnect}
              />
            )}
          </div>
          <p className={cl.AlertTextTopSub} >Ваша подписка кончается: {expiryTime}</p>
          <p 
            className={cl.AlertTextTop}
            onClick={() => {
                tg.close(); 
                window.open('https://teletype.in/@elr1cs_work/install-vpn', '_blank');
            }}
          >
            Ссылка на инструкцию для подключения
          </p>

          <p className={cl.AlertText}>
            Примечание: “elr1cs_work” не собирает и не передает данные о пользователях ни одному провайдеру. Также не хранит их у себя на сервере или еще где-то. Приятного пользования ;)
          </p>
        </div>
      ) : (
        <div className={cl.MobileAlertWrap}>
          <div className={cl.MobileAlert}>
            <img src={qr} alt="elr1c's_qr" />
            <hr />
            <input
              type="button"
              value="Скопировать ссылку"
              className={cl.copyBtn}
              onClick={() => copyTextToClipboardMobile('https://t.me/elr1cswork_bot')} // Логика копирования для мобильного
            />
          </div>

          <p className={cl.MobileAlertText}>Only on Mobile: Только для телефонов</p>
        </div>
      )}


          </>
      );
}

export default Main;